import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class Quotes {

    constructor() {
        this.sections = document.querySelectorAll('.block-quotes');
        this.instances = [];
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);

        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    rebuild() {
        this.instances.forEach(obj => {
            obj.main?.destroy(true, true);
        });
        this.instances = [];
        this.ready();
    }

    ready() {
        if (this.sections.length === 0) return;

        this.sections.forEach(section => {

            const slider = section.querySelector('.swiper');
            if (!slider) return;

            const navigationNext = section.querySelector('.slider-button-next');
            const navigationPrev = section.querySelector('.slider-button-prev');
            const pagination = section.querySelector('.swiper-pagination');

            const swiperInstance = new Swiper(slider, {
                modules: [Pagination, Navigation],
                spaceBetween: 24,
                grabCursor: true,
                // Keep native text selection available inside quote slides.
                touchStartPreventDefault: false,
                watchSlidesProgress: true,
                navigation: navigationNext && navigationPrev ? {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                } : false,
                pagination: pagination ? {
                    el: pagination,
                    clickable: true,
                } : false,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    1024: {
                        slidesPerView: 2,
                    }
                }
            });

            bindSwiperNavigationA11y(swiperInstance);

            this.instances.push({ main: swiperInstance });
        });
    }
}

if (document.querySelector('.block-quotes')) {
    new Quotes();
}
